import React, { useRef, useState } from "react";
import { Popup } from "antd-mobile";
import QRCode from "react-qr-code";
import { CopyToClipboard } from "react-copy-to-clipboard";
import useActiveState from "../../lib/useActiveState";
import "./css/InviteFriends.css";
import Dialog from "../../lib/Dialog";

export default function InviteAlert(props) {
  const { data } = props;
  const [user] = useActiveState("user");
  const [visible, setVisible] = useState(true);

  const items = [
    {
      key: "copy",
      title: "复制链接",
      img: "resources/251222/invite-alert-item0.png",
      value: data?.invite_link,
    },
    {
      key: "wechat",
      title: "微信好友",
      img: "resources/251222/invite-alert-item1.png",
      value: data?.invite_link,
    },
    {
      key: "qq",
      title: "QQ好友",
      img: "resources/251222/invite-alert-item2.png",
      value: data?.invite_link,
    },
  ];

  const handleClick = (item) => {
    setTimeout(() => {
      setVisible(false);
      if (props.onClose) {
        props.onClose();
      }
    }, 1000);
    if (item.key == "copy") {
    } else if (item.key == "wechat") {
      setTimeout(() => {
        window.location.href = "weixin://";
      }, 1000);
    } else if (item.key == "qq") {
      setTimeout(() => {
        window.location.href = "mqq://";
      }, 1000);
    }
  };

  return (
    <div className="invite-alert-index">
      <div className="invite-alert-content">
        <img src="resources/251222/invite-alert-bg.png" alt="" />

        <div className="invite-alert-container">
          <div className="invite-voucher-bg">
            <img src="resources/251222/invite-voucher-bg.png" alt="" />
            <div className="user-info">
              <img className="avatar" src={user.icon_link} alt="" />
              <div className="desc">
                兄弟，在这玩游戏真的太爽了！充值竟然打0.05折！
              </div>
            </div>
            <div className="invite-voucher">
              <img src={data?.share_claim_img} alt="" />
            </div>
            <div className="download">
              <div className="qrcode">
                <QRCode
                  value={data?.generate_qrcode_link}
                  size={42}
                  bgColor={"#ffffff"}
                  fgColor={"#000000"}
                  level={"H"}
                />
              </div>
              <div className="qrcode-desc">
                <div className="download-desc">
                  截图保存到相册，微信/QQ扫一扫识别二维码，下载即可领取~
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popup
        visible={visible}
        mask={false}
        bodyStyle={{
          padding: "20px 0",
          borderTopLeftRadius: 13,
          borderTopRightRadius: 13,
        }}
      >
        <div>
          <div>
            <div
              style={{
                fontSize: 15,
                fontWeight: 500,
                color: "#680C00",
                paddingLeft: 20,
              }}
            >
              分享到3个以上微信/QQ群，成功几率可提高
              <span style={{ color: "#E93925" }}>200%</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "20px 50px",
              }}
            >
              {items.map((item, index) => (
                <CopyToClipboard
                  text={item.value}
                  onCopy={() => Dialog.info("已复制到剪贴板")}
                >
                  <div
                    key={index}
                    style={{ marginRight: 30 }}
                    onClick={() => handleClick(item)}
                  >
                    <img src={item.img} alt={item.title} width={50} />
                    <div
                      style={{
                        fontSize: 12,
                        color: "#999",
                        paddingTop: 10,
                        textAlign: "center",
                      }}
                    >
                      {item.title}
                    </div>
                  </div>
                </CopyToClipboard>
              ))}
            </div>
            <div
              style={{
                textAlign: "center",
                color: "#999999",
                fontSize: 16,
                paddingTop: 10,
              }}
              onClick={() => {
                setVisible(false);
                if (props.onClose) {
                  props.onClose();
                }
              }}
            >
              取消
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}
